import { State, TabDisplayInterface, User } from '@wam/shared';
import { Injectable, OnDestroy, inject } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { map, takeUntil } from 'rxjs/operators';
import { authenticationSelectors } from '@wam/authentication';
import { isStaff } from '@app/authentication/user.data';

@Injectable({
  providedIn: 'root',
})
export class ReportsTabDisplayService implements TabDisplayInterface, OnDestroy {
  private store = inject<Store<State>>(Store);

  private destroyed$ = new Subject<void>();

  isFirst(): Observable<boolean> {
    return of(false);
  }

  shouldShow(): Observable<boolean> {
    const shouldShow = true;

    return this.store.pipe(
      select(authenticationSelectors.getCurrentUser),
      map((user: User) => shouldShow && isStaff(user)),
      takeUntil(this.destroyed$),
    );
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
